<template>
  <div class="checkout relative">
    <HeaderCheckout isPage="membresia" />
    <main class="checkout-component bg-gray-50 pt-20 md:pt-28">
      <div class="w-full bg-blue-100 py-12">
        <div
          class="
            max-w-7xl
            mx-auto
            flex flex-col
            container
            justify-center
            items-center
            content-center
            text-center
          "
        >
          <div class="mb-2">
            <img
              class="w-20 md:w-20 h-auto"
              src="../assets/img/logo-viva-fan-white.svg"
              alt=""
            />
          </div>
          <h2 class="text-white text-xl font-semibold">
            {{ thankyouTranslate[language].summary.title }}
          </h2>
        </div>
      </div>
      <section class="mx-auto flex flex-col lg:flex-row w-full pt-16 bg-white">
        <div class="mb-10 max-w-7xl mx-auto container">
          <div class="max-w-7xl mx-auto px-4">
            <h1 class="text-2xl text-green-400 mb-5 font-bold">
              {{ thankyouTranslate[language].summary.summary }}
            </h1>
            <div class="w-full">
              <div class="flex flex-col md:flex-row justify-start items-start">
                <div class="w-full md:w-1/3 pr-0 md:pr-20">
                  <div class="mb-5">
                    <h5 class="mb-1">
                      {{ thankyouTranslate[language].summary.membershipType }}
                    </h5>
                    <p v-if="subscription">
                      {{ subscription.subscription.name }}
                    </p>
                    <div v-if="loading" class="relative">
                      <img src="@/assets/img/app-loader.gif" class="w-6 h-6" />
                    </div>
                  </div>
                  <div class="mb-5">
                    <h5 class="mb-1">
                      {{ thankyouTranslate[language].summary.email }}
                    </h5>
                    <p v-if="account">
                      {{ account.contactDetails.emailAddress.email }}
                    </p>
                  </div>

                  <div class="mb-5" v-if="addOnsQuantity">
                    <h5 class="mb-1">Acompañantes adicionales</h5>
                    <p>{{ addOnsQuantity }}x acompañantes</p>
                  </div>
                </div>
                <div class="w-full md:w-1/3 pr-0 md:pr-20">
                  <div class="mb-5">
                    <h5 class="mb-1">
                      {{ thankyouTranslate[language].summary.expirationDate }}
                    </h5>
                    <p v-if="subscription">
                      {{ expireDate(subscription.subscription.renewalDate) }}
                    </p>
                    <div v-if="loading" class="relative">
                      <img src="@/assets/img/app-loader.gif" class="w-6 h-6" />
                    </div>
                  </div>
                  <div class="mb-5">
                    <h5 class="mb-1">
                      {{ thankyouTranslate[language].summary.customerId }}
                    </h5>
                    <p>{{ account.customerNumber }}</p>
                  </div>
                  <div class="mb-5">
                    <h5 class="mb-1">
                      {{ thankyouTranslate[language].summary.automaticRenewal }}
                    </h5>
                    <p v-if="subscription">
                      {{
                        thankyouTranslate[
                          language
                        ].summary.automaticRenewalDetails(
                          expireDate(subscription.subscription.renewalDate)
                        )
                      }}
                    </p>
                    <div v-if="loading" class="relative">
                      <img src="@/assets/img/app-loader.gif" class="w-6 h-6" />
                    </div>
                  </div>
                </div>
                <div class="w-full md:w-1/3">
                  <div class="mb-5">
                    <h5 class="mb-1">
                      {{ thankyouTranslate[language].summary.paymentType }}
                    </h5>
                    <p v-if="subscription">
                      {{ subscription.billing.cardDetails.cardType }}
                    </p>
                    <div v-if="loading" class="relative">
                      <img src="@/assets/img/app-loader.gif" class="w-6 h-6" />
                    </div>
                  </div>
                  <!-- <div class="mb-5">
                                        <h5 class="mb-1">Método de pago</h5>
                                        <p>Método de pago</p>
                                    </div> -->
                  <div class="border-b my-5"></div>
                  <div class="mb-5 flex justify-between">
                    <div class="font-bold text-lg">
                      <h3 class="text-green-500">
                        {{ thankyouTranslate[language].summary.yourPayment }}
                      </h3>
                      <p
                        class="text-blue-100 text-xs font-normal"
                        v-if="subscription"
                      >
                        <span
                          v-if="
                            subscription.subscription.currentAmount
                              .paymentTerm != 'Annual'
                          "
                        >
                          {{ thankyouTranslate[language].summary.payments }}
                        </span>
                      </p>
                    </div>
                    <div
                      class="font-bold text-lg text-green-500"
                      v-if="subscription"
                    >
                      <span
                        v-if="
                          couponCode?.couponCode == 'vfn_vivaaerobus_2023' &&
                          subscription.subscription.name.toLowerCase() ==
                            'viaja solo'
                        "
                      >
                        0.00 {{ currency }}
                      </span>
                      <span v-else>
                        ${{
                          subscription.subscription.currentAmount.netTotalAmount.toLocaleString(
                            "en",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )
                        }}
                        {{ currency }}
                      </span>
                    </div>
                    <div v-if="loading" class="relative">
                      <img src="@/assets/img/app-loader.gif" class="w-6 h-6" />
                    </div>
                  </div>
                  <div class="mb-5 flex justify-between">
                    <p class="mb-1">
                      {{ thankyouTranslate[language].summary.renewalCost }}
                    </p>
                    <p v-if="subscription">
                      ${{
                        Math.round(
                          parseFloat(
                            parseFloat(
                              subscription.subscription.renewalAmount.planAmount
                            ) *
                              parseFloat(
                                `1.${subscription.subscription.renewalAmount.taxPercentage}`
                              )
                          ) +
                            parseFloat(
                              parseFloat(
                                subscription.subscription.renewalAmount
                                  .addOnsAmount
                              ) *
                                parseFloat(
                                  `1.${subscription.subscription.renewalAmount.taxPercentage}`
                                )
                            )
                        ).toLocaleString("en", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      }}
                      {{ currency }}
                    </p>
                    <div v-if="loading" class="relative">
                      <img src="@/assets/img/app-loader.gif" class="w-6 h-6" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="bg-green-250 p-10 text-white" v-if="referral">
        <div class="max-w-7xl mx-auto px-4">
          <div class="flex justify-between">
            <div class="w-1/2">
              <h3 class="text-3xl font-semibold">
                <img
                  src="@/assets/img/icons/viva-cash.svg"
                  width="40"
                  class="inline"
                />
                {{ checkoutTranslate[language].checkout.title }}
              </h3>
            </div>
            <div class="w-1/2">
              <p class="pb-5">
                {{ checkoutTranslate[language].checkout.content }}
              </p>
              <router-link
                :to="{ name: 'DashboardPerfil' }"
                class="font-semibold mt-5"
              >
                {{ checkoutTranslate[language].checkout.viewBtn }}
                <FontAwesomeIcon :icon="faArrowRight" />
              </router-link>
            </div>
          </div>
          <div class="mt-5 border-white border-t"></div>
          <div class="mt-5">
            <p>{{ checkoutTranslate[language].checkout.subContent }}</p>
          </div>
        </div>
      </section>

      <section class="bg-gray-50 px-0 sm:px-10 md:px-20">
        <div
          class="
            container
            max-w-8xl
            mx-auto
            px-4
            py-5
            px-10
            sm:py-6
            md:pb-16 md:pt-10
          "
        >
          <div class="text-center max-w-3xl mx-auto">
            <h2 class="text-2xl text-green-400 font-bold">
              {{ thankyouTranslate[language].slides.reservation }}
            </h2>
          </div>
          <CarouselReservacion :wrap-around="true"></CarouselReservacion>
        </div>
      </section>

      <section class="bg-white px-0 sm:px-10 md:px-20 pt-5 pb-8">
        <div
          class="
            container
            max-w-8xl
            mx-auto
            px-4
            py-5
            px-10
            sm:py-6
            md:py-10
            lg:pb-0
          "
        >
          <div class="text-center mx-auto">
            <h2 class="text-2xl text-green-400 font-bold">
              {{ thankyouTranslate[language].slides.enjoy }}
            </h2>
          </div>
          <CarouselComienza :wrap-around="true"></CarouselComienza>
          <div class="mx-auto max-w-sm mt-5 mb-8">
            <router-link
              :to="{ name: 'DashboardSubscription' }"
              class="
                w-auto
                flex
                items-center
                justify-center
                px-8
                py-3
                text-base
                font-bold
                rounded-xl
                text-white
                bg-blue-100
                border-2 border-white
                hover:bg-white hover:bg-blue-200
                md:py-4 md:text-lg md:px-20
                text-center
              "
              >{{
                thankyouTranslate[language].summary.buttonLogin
              }}</router-link
            >
          </div>
        </div>
      </section>
    </main>
    <FooterCheckout />
  </div>
</template>

<script>
import HeaderCheckout from "@/components/header/Checkout.vue";
import FooterCheckout from "@/components/Footer.vue";
import CarouselReservacion from "@/components/carousel/CarouselReservacion.vue";
import CarouselComienza from "@/components/carousel/CarouselComienza.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useStore } from "vuex";
import { computed, ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import { checkoutTranslate } from "@/translations/Checkout.js";
import { thankyouTranslate } from "@/translations/ThankYou.js";
import { dataLayerPurchase } from "@/pixels/datalayer.js";

export default {
  name: "Membresia",
  components: {
    HeaderCheckout,
    FooterCheckout,
    CarouselReservacion,
    CarouselComienza,
    FontAwesomeIcon,
  },
  setup() {
    const store = useStore();
    const account = computed(() => {
      return store.state.Accounts.data;
    });
    const language = computed(() => {
      return localStorage.getItem("viva-translate")
        ? localStorage.getItem("viva-translate")
        : "es";
    });

    const selected = computed(() => {
      return store.state.Plans.selected;
    });

    const couponCode = computed(() => {
      return store.state.Checkout.data.coupon;
    });

    const loading = computed(() => {
      return store.state.Checkout.loading.subscription;
    });

    const addOnsQuantity = ref("");
    const referral = ref();
    const subscription = computed(() => {
      return store.state.Checkout.data.userSubscription.data;
    });

    const expireDate = (date) => {
      const expire = new Date(date);
      const options = { year: "numeric", month: "long", day: "numeric" };

      return expire.toLocaleDateString(
        language.value == "es" ? "es-ES" : "en-US",
        options
      );
    };

    const getAddOnsQuantity = () => {
      if (subscription.value) {
        if (subscription.value.subscription.subscriptionType != "Vfp") {
          if (subscription.value.subscription.subscriptionAddOns.length != 0) {
            subscription.value.subscription.subscriptionAddOns.forEach(
              (key) => {
                addOnsQuantity.value = key.quantity;
              }
            );
          }
        }
      }
    };

    const currency = computed(() => {
      return localStorage.getItem("viva-currency")
        ? localStorage.getItem("viva-currency")
        : "MXN";
    });


    onMounted(async () => {
      store.commit("LOADING_SUBSCRIPTION", true);
      await store.dispatch("getSubscription", { plan: "vfn" });
      getAddOnsQuantity();

      dataLayerPurchase(subscription.value, {
        ...selected.value,
        currency: currency.value,
      });

      store.commit("LOADING_SUBSCRIPTION", false);

      if (Object.keys(account.value).length == 0) {
        const url = window.location.href;
        const slash = url.substr(url.length - 1);
        if (slash === "/") {
          window.location.href = url.slice(0, -1);
        } else {
          window.location.href = url;
        }
      }
    });

    return {
      account,
      selected,
      subscription,
      addOnsQuantity,
      faArrowRight,
      expireDate,
      referral,
      checkoutTranslate,
      thankyouTranslate,
      language,
      currency,
      loading,
      couponCode,
    };
  },
};
</script>

<style scoped>
.box {
  @apply bg-white border border-gray-200 shadow rounded-lg text-left rounded-lg shadow overflow-hidden;
}
h4 {
  @apply text-lg md:text-xl text-green-400 font-bold;
}
h5 {
  @apply md:text-sm text-green-400;
  font-size: 0.75rem;
}
input.form-control {
  @apply font-semibold text-left focus:ring-green-400 focus:border-green-400 block w-full text-18 border-gray-300 rounded-md pt-7 pb-2 px-4 rounded-xl shadow-sm border text-green-500 outline-none;
}
label > span {
  @apply text-green-500 sm:text-xs;
}
.form-check-radio {
  @apply w-5 h-5 border-2 rounded-full bg-blue-100;
}
.form-radio-wrapper {
  @apply flex content-center items-center pt-5 pb-0 md:py-5 w-full md:w-auto;
}
.disabled {
  @apply opacity-50 cursor-not-allowed;
}
</style>
